import { AffiliateApi } from "@/api/affiliates";
import { UpdateAffiliateStatusRequest } from "@/api/affiliates/types/update-affiliate-status.types";
import { useUIStore } from "@/stores";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useChangeAffiliateStatus = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate: changeAffiliateStatus, isPending } = useMutation({
    mutationFn: (body: UpdateAffiliateStatusRequest) =>
      AffiliateApi.updateAffiliateStatus(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: () => {
      closeModal();
      queryClient.invalidateQueries({
        queryKey: [QueryKey.AFFILIATE_USER],
      });
      setTimeout(() => {
        notify("Affiliate status is updated!", { type: "success" });
      }, 250);
    },
  });

  return {
    changeAffiliateStatus,
    isChangeAffiliateStatusLoading: isPending,
  };
};
